import { AbstractControl, ValidatorFn } from '@angular/forms';

function parseDate(dateString: string): Date {
    const parts = dateString.split('/');

    return new Date(+parts[2], +parts[1] - 1, +parts[0]);
}

export function expirationDateValidator(
    getMinDate?: () => string | null,
): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const minDateValue = getMinDate?.();
        const parsedMinDate = minDateValue ? new Date(minDateValue) : null;
        const minDate =
            parsedMinDate && !isNaN(parsedMinDate.getTime())
                ? parsedMinDate
                : new Date();
        minDate.setHours(0, 0, 0, 0);
        const expirationDate = parseDate(control.value);

        return expirationDate < minDate
            ? { expirationDateInvalid: { value: control.value } }
            : null;
    };
}

export function emissionDateValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const today = new Date();
        const emissionDate = parseDate(control.value);

        return emissionDate >= today
            ? { emissionDateInvalid: { value: control.value } }
            : null;
    };
}

export function birthdayValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const today = new Date();
        const birthDate = parseDate(control.value);
        const age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        const dayDiff = today.getDate() - birthDate.getDate();

        const actualAge =
            monthDiff < 0 || (monthDiff === 0 && dayDiff < 0) ? age - 1 : age;

        if (birthDate > today) {
            return {
                birthdayInvalid: {
                    value: control.value,
                    reason: 'Future date',
                },
            };
        }

        if (actualAge <= 17) {
            return {
                birthdayInvalid: {
                    value: control.value,
                    reason: 'User is 18 years old or younger',
                },
            };
        }

        return null;
    };
}
